import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import { setFileFormat } from '../../reducers/BuildRenderRequestSlice';
import { useGetSettingsQuery } from '../../services/chromosomeApi';

export const DownloadFormats = () => {
  const dispatch = useDispatch();
  const { fileFormat } = useSelector((state: RootState) => state.buildRenderRequest);
  const { isLoading, data } = useGetSettingsQuery();

  if (isLoading) {
    return <div style={{ color: 'var(--muted)', fontSize: '.8rem' }}>Loading…</div>;
  }

  return (
    <>
      <div className="radio-group">
        {(data?.availableFileFormats || []).map(format => (
          <label key={format.value} className="radio-row">
            <input
              type="radio"
              name="fileFormat"
              value={format.value}
              checked={fileFormat === format.value}
              onChange={() => dispatch(setFileFormat(format.value))}
            />
            <span>{format.name}</span>
          </label>
        ))}
      </div>
      <p className="radio-note">** Only PNG is supported right now!</p>
    </>
  );
};
